import { useState } from 'react';
import AboutModal from '../../pages/home/components/AboutModal';
import CareersModal from '../../pages/home/components/CareersModal';
import CertificationsModal from '../../pages/home/components/CertificationsModal';
import PrivacyPolicyModal from '../../pages/home/components/PrivacyPolicyModal';
import TermsOfServiceModal from '../../pages/home/components/TermsOfServiceModal';

export default function Footer() {
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isCareersOpen, setIsCareersOpen] = useState(false);
  const [isCertificationsOpen, setIsCertificationsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
    <footer className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-10 md:mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4 md:mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/95973eac-e27a-474d-996f-33ddc4a2bb23.png"
                alt="McALLISTER DELIGHT Logo"
                title="McALLISTER DELIGHT"
                className="h-8 md:h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4 md:mb-6">
              Leading provider of food logistics solutions in Canada. Reliability, quality, and safety you
              can count on.
            </p>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">Services</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Refrigerated Transport
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Cold Storage Warehousing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Distribution
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Cross-Docking
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Consulting
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">Company</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); setIsAboutOpen(true); }}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); setIsCareersOpen(true); }}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); setIsCertificationsOpen(true); }}
                  className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm cursor-pointer"
                >
                  Certifications
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0">
            <p className="text-gray-400 text-xs md:text-sm text-left">
              &copy; 2019 McALLISTER DELIGHT. All rights reserved
            </p>
            <div className="flex items-center flex-wrap justify-start md:justify-end gap-4 md:gap-6">
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setIsPrivacyOpen(true); }}
                className="text-gray-400 hover:text-white transition-colors text-xs md:text-sm cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setIsTermsOpen(true); }}
                className="text-gray-400 hover:text-white transition-colors text-xs md:text-sm cursor-pointer whitespace-nowrap"
              >
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors text-xs md:text-sm cursor-pointer"
              >
                
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <AboutModal isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
    <CareersModal isOpen={isCareersOpen} onClose={() => setIsCareersOpen(false)} />
    <CertificationsModal isOpen={isCertificationsOpen} onClose={() => setIsCertificationsOpen(false)} />
    <PrivacyPolicyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
    <TermsOfServiceModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
    </>
  );
}
